import { render } from "./Cartridge.vue?vue&type=template&id=6452b4f0"
import script from "./Cartridge.vue?vue&type=script&lang=js"
export * from "./Cartridge.vue?vue&type=script&lang=js"

import "./Cartridge.vue?vue&type=style&index=0&id=6452b4f0&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__